import {Checkbox} from "@material-ui/core";
import React, {useEffect, useState} from "react";

interface IPermissionCheckBoxProps {
    isActive: boolean;
}

export const PermissionCheckbox = ({isActive}: IPermissionCheckBoxProps) => {
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        setChecked(isActive || false);
    }, []);
    
    const onClick = () => {
        setChecked(!checked);
    }
    
    return (
        <Checkbox
            checked={checked}
            onClick={() => onClick()}
            color="default"
            style={{
                padding: 0,
                margin: "0 10px",
                borderWidth: "1.5px !important"
            }}
        />
    );
}